import { Inbox, type LucideIcon } from 'lucide-react';
import { StateMessage } from '@/components/common/StateMessage';
import { TableCell, TableRow } from '@/components/ui/table';

interface DataTableEmptyProps {
  columnCount: number;
  icon?: LucideIcon | undefined;
  message?: string | undefined;
  hint?: string | undefined;
}

export function DataTableEmpty({
  columnCount,
  icon = Inbox,
  message = 'No results found',
  hint = 'Try adjusting filters or search to see more.',
}: DataTableEmptyProps) {
  return (
    <TableRow className="hover:bg-transparent border-b-0 h-full">
      <TableCell colSpan={columnCount} className="h-48 text-center align-middle">
        <div className="flex justify-center">
          <StateMessage
            icon={icon}
            tone="neutral"
            title={message}
            description={hint}
            size="compact"
          />
        </div>
      </TableCell>
    </TableRow>
  );
}
